import { createFileRoute } from '@tanstack/react-router';

import { ensureRecord, requirePermission } from '@/app/guards';
import { BankOnboardingPage, bankQuery } from '@/features/banks-products';
import { NotFoundView } from '@/features/shell';

/** Adds another product to an existing bank, starting its configuration as draft v1. */
export const Route = createFileRoute('/_app/banks/$bankId/products/new')({
  staticData: { crumb: 'banksProducts:onboarding.addProductCrumb' },
  beforeLoad: ({ context }) => requirePermission(context.queryClient, 'config.edit', 'Setup'),
  loader: async ({ context, params }) => {
    await ensureRecord(context.queryClient.query({ ...bankQuery(params.bankId), staleTime: 'static' }));
  },
  notFoundComponent: function BankNotFound() {
    const { bankId } = Route.useParams();
    return <NotFoundView reference={bankId} />;
  },
  component: function AddProduct() {
    const { bankId } = Route.useParams();
    const navigate = Route.useNavigate();
    return (
      <BankOnboardingPage
        bankId={bankId}
        onDone={({ product, versionNo }) => void navigate({ to: '/banks/$bankId/products/$productId/versions/$versionNo', params: { bankId, productId: product, versionNo: String(versionNo) } })}
        onCancel={() => void navigate({ to: '/banks/$bankId', params: { bankId } })}
      />
    );
  },
});
